import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class JsonLdService {

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) { }

    /**
     * Add JSON-LD to the document head
     * @param data The JSON-LD data object
     */
    addJsonLd(...jsons: any) {
        // Remove existing JSON-LD scripts to prevent duplicates
        this.removeJsonLd();

        for (let json of jsons) {
            const script = this.document.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(json);
            this.document.head.appendChild(script);
        }
    }

    /**
     * Remove all JSON-LD scripts from the document head
     */
    removeJsonLd() {
        const scripts = this.document.querySelectorAll('script[type="application/ld+json"]');
        scripts.forEach(script => script.remove());
    }

    /**
     * Setup route change listener to update JSON-LD on route changes
     * This uses your existing route data
     */
    setupRouteListener() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map(route => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter(route => route.outlet === 'primary'),
            mergeMap(route => route.data)
        ).subscribe(routeData => {
            // Use the existing meta tag data to generate JSON-LD
            this.generateFromRouteData(routeData);
        });
    }

    /**
     * Generate JSON-LD from existing route data (meta tags)
     */
    generateFromRouteData(routeData: any) {
        if (!routeData) return;

        // Use the meta tag data directly for the JSON-LD
        // const jsonLd = {
        //     '@context': 'https://schema.org',
        //     '@type': 'TechArticle',
        //     'headline': routeData.title || 'KudosHub Documentation',
        //     'description': routeData.description || '',
        //     'keywords': routeData.keywords || '',
        //     'url': routeData.ogUrl || `https://kudoshub.com${this.router.url}`,
        //     'image': routeData.ogImage || 'https://kudoshub.com/theme/images/og-images/logo.webp',
        //     'author': {
        //         '@type': 'Organization',
        //         'name': 'KudosHub Technologies',
        //         'url': 'https://kudoshub.com'
        //     },
        //     'publisher': {
        //         '@type': 'Organization',
        //         'name': 'KudosHub Technologies',
        //         'logo': {
        //             '@type': 'ImageObject',
        //             'url': 'https://kudoshub.com/theme/images/og-images/logo.webp'
        //         }
        //     },
        //     'dateModified': new Date().toISOString(),
        // };

        // this.addJsonLd(jsonLd);
    }
}